import React from "react";

function HealthProfileQuestion({ text, className }) {
  return <p className={`font-medium text-2xl ${className}`}>{text}</p>;
}

export default HealthProfileQuestion;
